import React from "react";

const ITEMS = [
  "Just Eat",
  "Deliveroo",
  "Uber Eats",
  "Panda",
  "Walk In Welcome",
  "Collection Available",
  "Detroit Pizza",
  "Peri Peri",
  "Ramen & Maki",
  "Chinese",
  "Fish & Chips",
  "Edinburgh-Made",
  "Indian Curries",
  "Burgers & Wings",
  "Shawarma",
  "Halal",
  "Desserts",
  "Parathas",
  "Many More",
];

export default function Ticker() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      className="bg-[var(--gold)] overflow-hidden border-y border-[var(--border)]"
      data-testid="ticker"
    >
      <div className="ticker-track py-4">
        {row.map((item, i) => (
          <div
            key={i}
            className="flex items-center px-7 font-display text-[26px] text-[var(--bg)] whitespace-nowrap"
          >
            {item}
            <span className="mx-7 w-[6px] h-[6px] rounded-full bg-[var(--bg)]" />
          </div>
        ))}
      </div>
    </div>
  );
}
